import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { SecondaryButton, PrimaryButton } from '@cbridge-tools/button';
import { IDetailsSidebarEditControlsProps } from './DetailsSidebarEditControls.interface';

export const DetailsSidebarEditControls: FunctionComponent<IDetailsSidebarEditControlsProps> = (props) => {
  const { loading, disabled, submitButtonLabel, onSubmit, onCancel } = props;

  const { t } = useTranslation();

  return (
    <>
      <PrimaryButton
        label={submitButtonLabel ?? t('text:common.button.save')}
        disabled={disabled}
        loading={loading}
        onClick={onSubmit}
      />
      <SecondaryButton label={t('text:common.button.cancel')} onClick={onCancel} />
    </>
  );
};
